import { render, staticRenderFns } from "./view-dealer.vue?vue&type=template&id=34dffd78&"
import script from "./view-dealer.vue?vue&type=script&lang=js&"
export * from "./view-dealer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports